module.exports = __webpack_public_path__ + "img/icon-current_status_offline.6fdf6ed5.svg";